module.exports = __webpack_public_path__ + "static/img/Logotipo_5.036a2c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_transparente/Logotipo_5.png
// module id = 101
// module chunks = 0